import { Badge } from '../../catalyst/badge';
import type { GroupViewNode } from './graphModel';

type Props = {
  groups: GroupViewNode[];
  onExpand: (group: GroupViewNode) => void;
};

/** The groups the selected node shows once expanded; a click expands the node and the group. */
export function ChildGroupList({ groups, onExpand }: Props) {
  if (groups.length === 0) return null;
  return (
    <div className="flex flex-col gap-1 text-sm text-zinc-900 dark:text-zinc-100">
      <div className="font-medium">Children</div>
      <ul className="flex flex-col">
        {groups.map((group) => (
          <li key={group.id}>
            <button
              type="button"
              className="flex w-full items-center justify-between gap-2 rounded-md px-2 py-1 text-left hover:bg-zinc-100 dark:hover:bg-zinc-700"
              onClick={() => onExpand(group)}
            >
              <span className="min-w-0 truncate">{group.label}</span>
              <Badge color="zinc">{group.total.toLocaleString('en-US')}</Badge>
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
